module.exports = __webpack_public_path__ + "img/home-content-2.f8ec74a9.png";